<template>
  <div>
    <PageHeadline v-if="!isApp" title="購入履歴" />
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <feedback-error v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isLoadingHistory" class="loading-section">
      <loading />
    </div>
    <div v-else-if="!isEmptyResult" class="order-history-section__main">
      <div class="order-history-section__order-history-boxes">
        <order-history-box
          v-for="orderHistory in orderHistories"
          :id="orderHistory.id"
          :key="orderHistory.id"
          :order-code="orderHistory.orderCode"
          :message="orderHistory.message"
          :created-at="orderHistory.createdAt"
          :item-sku-content="orderHistory.itemSkuContent"
          :item-sku-contents-count="orderHistory.itemSkuContentsCount"
          :wish-list-user="orderHistory.wishListUser"
          :is-app="isApp"
        />
      </div>
      <div class="order-history-section__pagination">
        <Pagination
          :current-page="currentPage"
          :total-pages="totalPages"
          @clicked="changePage"
        />
      </div>
      <div v-if="!isApp" class="order-history-section__to-giftee-top-area">
        <a
          href="/"
          class="order-history-section__to-giftee-top-link text-link-to-top"
        >
          gifteeトップへ戻る
        </a>
      </div>
    </div>
    <div v-else class="order-history-section__main">
      <div class="order-history-section__empty-result-message-area">
        <p class="order-history-section__empty-result-message">
          購入したギフトはここに表示されます
        </p>
      </div>
      <div v-if="!isApp" class="order-history-section__to-giftee-top-area">
        <a
          href="/"
          class="order-history-section__to-giftee-top-link text-link-to-top"
        >
          gifteeトップへ戻る
        </a>
      </div>
    </div>
    <div
      v-if="!isEmptyResult && !isApp"
      class="order-history-section__to-top-area"
    >
      <button
        class="order-history-section__to-top-button text-link-to-top"
        @click="scrollToTop"
      >
        ページトップへ
      </button>
    </div>
  </div>
</template>

<script>
import Loading from '../../atoms/loadings/Loading.vue'
import OrderHistoryBox from '../../organism/mypages/order_histories/OrderHistoryBox.vue'
import Pagination from '../../organism/paginations/Pagination.vue'
import FeedbackError from '../../atoms/feedbacks/feedback-error.vue'
import PageHeadline from '../../molecules/headlines/PageHeadline.vue'
import axios from 'axios'
import url from 'url'
import qs from 'qs'

export default {
  components: {
    Loading,
    OrderHistoryBox,
    Pagination,
    FeedbackError,
    PageHeadline
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      orderHistories: [],
      isLoadingHistory: false,
      showPageCounts: [],
      currentPage: 1,
      totalPages: 1,
      showableErrorFeedback: false,
      errorMessage: ''
    }
  },
  computed: {
    isEmptyResult() {
      return this.orderHistories.length === 0
    }
  },
  mounted() {
    this.initializeParams()
    this.getPurchaseHistories(this.currentPage)

    // NOTE: ブラウザバック・フォワード時の更新処理
    window.onpopstate = async function() {
      this.initializeParams()
      await this.getPurchaseHistories(this.currentPage)
    }.bind(this)
  },
  methods: {
    initializeParams() {
      const urlQuery = url.parse(location.href).query
      if (!urlQuery) {
        this.currentPage = 1
        return
      }
      const parsed = qs.parse(urlQuery)
      this.currentPage = parsed.page ? Number(parsed.page) : 1
    },
    updateUrlFromParams() {
      history.pushState(
        '',
        '',
        this.currentPage <= 1
          ? '/mypage/order_histories'
          : `/mypage/order_histories?page=${this.currentPage}`
      )
    },
    async getPurchaseHistories(page) {
      this.isLoadingHistory = true

      try {
        const res = await axios.get(
          `/api/v1/users/@me/order_histories?page=${page}&limit=10`
        )
        if (res.data.length === 0) {
          this.isLoadingHistory = false
          return
        }
        const { current_page, total_pages } = res.data.meta
        this.currentPage = current_page
        this.totalPages = total_pages
        this.orderHistories = res.data.data
          .map(order => order.attributes)
          .map(order => {
            // TODO: dummyimage を正式が画像に置換する
            const itemSkuImageUrl = order.first_item_sku_content_image_url
              ? order.first_item_sku_content_image_url
              : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
            const message = order.message || 'メッセージはありません'
            return {
              id: order.id,
              orderCode: order.order_code,
              message: message,
              createdAt: order.created_at,
              itemSkuContentsCount: order.item_sku_contents_count,
              itemSkuContent: {
                itemId: order.first_item_sku_content_item_id,
                itemSkuId: order.first_item_sku_content_item_sku_id,
                itemSkuName: order.first_item_sku_content_name,
                itemName: order.first_item_sku_content_item_name,
                brandName: order.first_item_sku_content_brand_name,
                imageUrl: itemSkuImageUrl
              },
              wishListUser: {
                showable: order.wish_list_user_showable,
                iconUrl: order.wish_list_user_icon_url,
                nickname: order.wish_list_user_nickname,
                wishListUrl: order.wish_list_url
              }
            }
          })
        this.isLoadingHistory = false
      } catch (error) {
        this.isLoadingHistory = false
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async changePage(page) {
      this.scrollToTop()
      await this.getPurchaseHistories(page)
      this.updateUrlFromParams()
    },
    scrollToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
.order-history-section {
  &__order-history-boxes {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}
</style>
